import { render, staticRenderFns } from "./Order.vue?vue&type=template&id=05d50270&scoped=true&"
import script from "./Order.vue?vue&type=script&lang=js&"
export * from "./Order.vue?vue&type=script&lang=js&"
import style0 from "./Order.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Order.vue?vue&type=style&index=1&id=05d50270&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d50270",
  null
  
)

export default component.exports